<template>
  <li :class="{ checked: item.checked }">
    <div class="titleWrap">
      <div class="title" :title="item.text">
        <span v-if="!item.url">{{ item.text }}</span>
        <a v-if="item.url" :href="item.url" target="_blank">
          <inline-svg :src="require('@/assets/external-link-svgrepo-com.svg')" class="ext-icon" width="18" height="18"
            stroke="#69A1B5" aria-label="My image"></inline-svg>{{ item.text }}
        </a>
      </div>
      <div class="price">
        <span>{{ item.price }} €</span>
      </div>
    </div>

    <div>
      <button @click="selectItem(item)">
        {{ item.checked ? 'Повернути' : 'Подарувати' }}
      </button>
    </div>
  </li>
</template>


<script>

export default {
  name: 'WishListItem',
  emits: ['selectedItem'],
  props: {
    item: Object
  },
  methods: {
    selectItem(item) {
      this.$emit('selectedItem', item);
    }
  }
}
</script>

<style scoped>
li {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  padding: 8px;
  text-align: left;
  list-style-type: none;
  font-size: 1.25em;
  line-height: 150%;
}

li:hover {
  background: #f5f5f5;
}

.titleWrap {
  max-width: 100%;
  overflow: hidden;
}

.title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.price {
  height: 25px;
  font-size: 0.7em;
  color: #666;
}

.checked .title {
  color: #909090;
  text-decoration: line-through;
}

.ext-icon {
  margin-right: 5px;
}

.ext-icon,
a {
  color: #69A1B5;
  vertical-align: middle;
}

.checked a {
  text-decoration: none;
}

button {
  background: transparent;
  color: #69A1B5;
  font-weight: bold;
  text-align: center;
  border: 1px solid currentColor;
  border-radius: 5px;
  padding: 6px 10px;
  cursor: pointer;
  width: 120px;
}

button:hover {
  background-color: #69a1b51b;
}


.checked button {
  color: #666;
}
</style>
